import React, { useState, useEffect } from "react"
import { getPermList } from "../../../services/permissionsApis"
import { getManagerPanelList } from "../../../services/managerPanelApis"
import Input from "../../Input"
import { useAuth } from "../../../lib/useAuth"
import { useSocket, useSocketEvent } from "../../../contexts/SocketContext"

const Permissions = ({
    user,
    handlePermissionsOnChange,
    selectedPerms,
    templateName,
    validateTemplateName,
    indexSlide,
    permList,
    goToSlide,
    botPanelId,
}) => {
    const [panels, setPanels] = useState(null)

    const findIndex = (e) => {
        const res = Object.entries(indexSlide).find(([key, value]) => e.target.name == key)
        if (res) {
            return res[1]
        } else {
            return null
        }
    }

    useEffect(() => {
        if (user) {
            if (user.scope === "admin") {
                getManagerPanelList(user.token).then(({ data }) => {
                    setPanels(data.filter((p) => p.status !== "offline"))
                })
            }
        }
    }, [user])

    return (
        <>
            <div className="mx-14 h-full">
                <div className={panels && user.scope == "admin" ? "grid grid-cols-2 gap-5" : null}>
                    <div className="">
                        <Input
                            type="text"
                            name="bot-templatename"
                            label=" اسم تمپلیت بات"
                            placeholder="اسم تمپلیت"
                            defaultValue={templateName}
                            onChange={validateTemplateName}
                            disabled={templateName ? true : false}
                            required={true}
                        />
                        <span id="templateNameLabel">
                            <div class="show_info text-sm text-red-400">نامعتبر</div>
                        </span>
                    </div>
                    {panels && user?.scope == "admin" ? (
                        <div className="">
                            <label className="block">پنل ها</label>
                            <div class="">
                                <select
                                    class="styled-select"
                                    name="panel-id"
                                    placeholder="انتخاب کن"
                                    defaultValue={botPanelId}
                                    required
                                >
                                    {panels &&
                                        panels.map((item, index) => (
                                            <option key={index} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className="list flex-grow mt-5" style={{ height: "calc(100% - 40px)" }}>
                    <table>
                        <thead className="list-header">
                            <tr>
                                <th className="w-[10%]">ردیف</th>
                                <th>اسم</th>
                                <th className="w-[30%]">قیمت هر ماه</th>
                                <th className="w-[15%] text-left">تعداد</th>
                            </tr>
                        </thead>
                        <tbody>
                            {permList &&
                                permList.map((item, index) => (
                                    <tr key={index}>
                                        <td className="checkbox-holder">
                                            <input
                                                type="checkbox"
                                                id={item.name}
                                                onChange={
                                                    item.name !== "createBot"
                                                        ? () => handlePermissionsOnChange(item.name)
                                                        : null
                                                }
                                                defaultChecked={
                                                    item.name !== "createBot"
                                                        ? selectedPerms && selectedPerms[item.name]
                                                            ? selectedPerms[item.name].checked
                                                            : false
                                                        : true
                                                    // selectedPerms && selectedPerms[item.name].checked
                                                    //     ? true
                                                    //     : item.name === "createBot"
                                                    //       ? true
                                                    //       : false
                                                }
                                                disabled={item.name == "createBot"}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                role="span"
                                                name={item.name}
                                                onClick={(e) => goToSlide(findIndex(e))}
                                            >
                                                {item.desc}
                                            </button>
                                        </td>
                                        <td>{item.price}</td>
                                        <td>
                                            {item.multi ? (
                                                <input
                                                    type="number"
                                                    id={item.name + "-multi"}
                                                    onChange={() => handlePermissionsOnChange(item.name)}
                                                    className="styled-input text-center h-7 w-8 bg-transparent text-white focus:outline-none font-sans"
                                                    defaultValue={
                                                        selectedPerms && selectedPerms[item.name]
                                                            ? selectedPerms[item.name].multi
                                                            : 1
                                                    }
                                                />
                                            ) : null}
                                        </td>
                                    </tr>
                                ))}
                            <tr></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default Permissions
